import React, { useState } from 'react';
import Self from '../../assets/images/self.png';
import Other from '../../assets/images/360.png';
import communication from '../../assets/images/communication.png';
import charisma from '../../assets/images/charishma.png';
import clarity from '../../assets/images/clarity.png';
import collaborate from '../../assets/images/colloborate.png';
import composure from '../../assets/images/composure.png';
import confidence from '../../assets/images/confidence.png';
import connection from '../../assets/images/connection.png';
import courage from '../../assets/images/courage.png';

const GuideAsmt = ({ name, onContinue }) => {
    const [assessmentType, setAssessmentType] = useState(name ? '360' : 'self'); // Set based on name prop

    return (
        <div className=" mx-auto p-4 lg:px-16">
            <h3 className="text-center text-black mb-4">Your Executive Presence is evaluated based on these seven key elements...</h3>
            <div className="text-center mb-8 space-y-6 px-4 lg:px-16">
  {/* Top Row - 4 cards */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
    {[
      { src: communication, title: 'Communication', description: 'The ability to clearly explain and present ideas in a way that captures attention and inspires enthusiasm.' },
      { src: charisma, title: 'Charisma', description: 'A positive aura and a commanding presence.' },
      { src: collaborate, title: 'Collaborate', description: 'A We-centric approach, always willing to work with others and offers support whenever needed.' },
      { src: composure, title: 'Composure', description: 'The ability to stay calm and composed during challenging times.' },
    ].map((item, index) => (
      <div key={index} className="bg-white p-4 rounded-lg shadow-md flex flex-col items-center">
        <img src={item.src} alt={item.title} className="w-10 h-10 mb-2" />
        <h3 className="font-bold text-sm mb-2">{item.title}</h3>
        <p className="text-gray-600 text-xs">{item.description}</p>
      </div>
    ))}
  </div>

  {/* Bottom Row - 3 cards, each span more space to match full width */}
  <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-12 gap-6">
    {[
      { src: clarity, title: 'Clarity', description: 'Having clarity of their strengths, internal drivers, key values, and desired outcomes.' },
      { src: connection, title: 'Connection', description: 'Having the ability to empathize and establish long-term sustainable relationships.' },
      { src: courage, title: 'Courage', description: 'Having a tendency and ability to stand up for what they consider as right.' },
    ].map((item, index) => (
      <div key={index} className="col-span-4 bg-white p-4 rounded-lg shadow-md flex flex-col items-center">
        <img src={item.src} alt={item.title} className="w-10 h-10 mb-2" />
        <h3 className="font-bold text-sm mb-2">{item.title}</h3>
        <p className="text-gray-600 text-xs">{item.description}</p>
      </div>
    ))}
  </div>
</div>


            <div className="lg:flex items-center justify-between gap-8">
                <div className="flex justify-center lg:w-1/2">
                    <img
                        src={assessmentType === 'self' ? Self : Other}
                        alt="Assessment Type"
                        className="rounded-lg shadow-lg "
                    />
                </div>
                <div className="assessment-instructions lg:w-1/2 bg-white p-6 rounded-2xl shadow-lg transition-all duration-300 ease-in-out hover:shadow-xl flex flex-col justify-center items-center gap-4">
                    <h2 className="text-lg font-bold">ASSESSMENT INSTRUCTIONS:</h2>
                    <p className="lg:w-[500px] text-center">
                        Please answer each question honestly and thoughtfully. Your responses will help us provide accurate and actionable feedback.
                    </p>
                    <button
                        className="bg-blue-500 text-white p-3 rounded-lg mt-4 transition duration-300 ease-in-out hover:bg-blue-600 hover:shadow-lg"
                        onClick={onContinue} // Trigger the continuation when the button is clicked
                    >
                        START {assessmentType === 'self' ? 'SELF ASSESSMENT' : 'ASSESSMENT'}
                    </button>
                </div>
            </div>
        </div>
    );
};



export default GuideAsmt;